'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { LayoutDashboard, Building2, BarChart3, Bell, BookMarked } from 'lucide-react';

const bottomNavItems = [
  { href: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { href: '/project-listings-screen', label: 'Projects', icon: Building2 },
  { href: '/analytics', label: 'Analytics', icon: BarChart3 },
  { href: '/alerts', label: 'Alerts', icon: Bell },
  { href: '/saved', label: 'Saved', icon: BookMarked },
];

export default function MobileBottomNav() {
  const pathname = usePathname();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-card/95 backdrop-blur-md border-t border-border safe-area-inset-bottom">
      <div className="flex items-center justify-around px-2 py-2">
        {bottomNavItems?.map((item) => {
          const isActive = pathname === item?.href || pathname?.startsWith(item?.href + '/');
          return (
            <Link
              key={item?.href}
              href={item?.href}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-all min-w-0 ${
                isActive
                  ? 'text-amber-400' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              <item.icon size={20} className={isActive ? 'text-amber-400' : ''} />
              <span className={`text-[9px] font-medium truncate ${isActive ? 'text-amber-400' : 'text-muted-foreground'}`}>
                {item?.label}
              </span>
              {isActive && <span className="w-1 h-1 bg-amber-400 rounded-full" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
